import './BlogCards.css';

const blogPosts = [
  {
    id: 1,
    date: 'Jan 09, 2026',
    title: 'Best Dabba Trading App in India: Pros, Cons & Market',
    image: 'https://images.pexels.com/photos/6801874/pexels-photo-6801874.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 2,
    date: 'Jan 08, 2026',
    title: 'Dabba Trading Platform Guide: Apps, Brokers & Execution Flow',
    image: 'https://images.pexels.com/photos/6802042/pexels-photo-6802042.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 3,
    date: 'Jan 08, 2026',
    title: 'Dabba Trading App vs Regulated Trading Apps – Major Differences',
    image: 'https://images.pexels.com/photos/7567443/pexels-photo-7567443.jpeg?auto=compress&cs=tinysrgb&w=800'
  },
  {
    id: 4,
    date: 'Jan 08, 2026',
    title: 'Top Dabba Trading App in India – Features, Fees &',
    image: 'https://images.pexels.com/photos/8370752/pexels-photo-8370752.jpeg?auto=compress&cs=tinysrgb&w=800'
  }
];

const BlogCards = () => {
  return (
    <section className="blog-cards">
      <div className="blog-container">
        <div className="blog-grid">
          {blogPosts.map(post => (
            <div key={post.id} className="blog-card">
              <div className="blog-image">
                <img src={post.image} alt={post.title} />
                <span className="blog-date">{post.date}</span>
              </div>
              <div className="blog-content">
                <h3 className="blog-title">{post.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogCards;
